export enum StatusEvento {
    Aberto = 1,
    Publicado = 2,
    Fechado = 3,
    Excluido = 4,
  }